export enum VatRate { Rate0 = 0, Rate9 = 1, Rate21 = 2 }

const VatRateValues = [
    { value: VatRate.Rate0, label: '0%' },
    { value: VatRate.Rate9, label: '9%' },
    { value: VatRate.Rate21, label: '21%' },
];

export const VatRateOptions = VatRateValues.map(rate => ({ value: rate.value, label: rate.label }));
